import React from 'react';
import PageWrapper from '../layout/PageWrapper';
import { Map } from 'lucide-react';
import HorseMap from '../components/HorseMap';
import { LuMapPinned } from "react-icons/lu"

/**
 * Carte pleine largeur/hauteur harmonisée.
 * - Annule le padding horizontal du layout via marges négatives
 * - Hauteur mobile: 100dvh - header(72) - bottomNav(64) - safe-area
 * - Hauteur desktop: 100dvh - header(96)
 */
export default function CartePage() {
  return (
    <PageWrapper icon={LuMapPinned} title="Carte" maxWidth="max-w-full">
      <div className="-mx-4 md:-mx-8">
        <div
          className="w-full h-[calc(100dvh-72px-64px-env(safe-area-inset-bottom))] md:h-[calc(100dvh-96px)]"
        >
          <HorseMap />
        </div>
      </div>
    </PageWrapper>
  );
}
